module.exports = __webpack_public_path__ + "img/bg-up-about-me.42164691.svg";